@if (searchContainer.searchResultViewName === 'list' && listFieldTemplateId) {
  <div class="search-view-full-header__title">
    <span>
      {{ 'TRANS__SEARCH_VIEW_FULL_HEADER__SEARCH_FIELDS_TITLE' | translate }}
    </span>

    <app-object-name
      class="search-view-full-header__template-name"
      [object]="listFieldTemplateObject"
      [objectId]="listFieldTemplateId"
    ></app-object-name>

    @if (operationContainer) {
      <ng-container>
        @for (operation of operationContainer.operations; track $index) {
          <ng-container>
            <button
              mat-icon-button
              class="search-view-full-header__operation-button"
              (click)="openOperation(operation)"
              [title]="operation.menu_title | translate"
            >
              <i class="{{operation.menu_icon}}"></i>
            </button>
          </ng-container>
        }
      </ng-container>
    }
  </div>
}
